import React, { Children } from "react";
import Plus2 from "../Atomos/Icons/Plus";
import NewButton from "../Atomos/Buttons/newButton";
import { Link } from "react-router-dom";
import "../../assets/css/table/Table.css";
import useViewport from "../../hooks/useViewPort";
import "../../assets/css/CatalogTable.css";
import CatalogTitle from "../Moleculas/Catalog Text/CatalogTitle";
import CounterTotalCatalog from "../Moleculas/Catalog Text/CounterTotalCatalog";
import { useStaffMode } from "../../hooks/StaffModeProvider";

interface ICatalogTableProps {
  newItemAction?: () => void;
  title?: string;
  catalogName?: string;
  route: string;
  totalCount: number | undefined;
  linkToAdd?: string;
  noNewCatalog?: boolean;
  catalogShortName?: string;
  children?: React.ReactNode;
  state?: {};
  dataAdminChildren?: any;
  exportMapper?: Function;
  rightActions?: React.ReactNode;
  /** Extra classes for the white content wrapper, e.g. to drop its default padding. */
  contentClassName?: string;
}

const CatalogTableC: React.FC<ICatalogTableProps> = (
  props: ICatalogTableProps
) => {
  const { viewportWidth } = useViewport();
  const isTouchDevice = "maxTouchPoints" in navigator && navigator.maxTouchPoints > 0;
  const { isStaffMode } = useStaffMode();
  const isTabletOrMobile = viewportWidth < 1024 || isTouchDevice;

  return (
    <>
      <section className="CatalogTableMain relative w-full self-stretch">
        <div className={`flex flex-col md:flex-row md:items-stretch md:justify-between gap-0 w-full relative self-stretch min-h-[2.5rem] ${isStaffMode ? 'bg-accent-Default-dark' : 'bg-primary-dark'} text-neutral p-0`}>
          <CounterTotalCatalog
            title={`${props.catalogName?.toUpperCase()} (${props.totalCount ?? 0} Total)`}
            className="!p-0 !px-2 bg-transparent text-neutral flex items-center"
          />
          <div className="flex items-stretch flex-shrink-0 self-stretch">
            {props.rightActions}
            {!props.noNewCatalog && !props.rightActions && (
              <Link
                to={
                  props.linkToAdd
                    ? (props.linkToAdd as string)
                    : 'Create'
                }
                state={props.state}
              >
                <NewButton
                  text={
                    isTabletOrMobile
                      ? 'Create'
                      : `Create ${props.catalogShortName ?? `${props.catalogName}`}`
                  }
                  color={isStaffMode ? "accent" : "primary"}
                  size={"large"}
                  onClick={() => props.newItemAction && props.newItemAction()}
                  content="textIcon"
                  icon={<Plus2 />}
                />
              </Link>
            )}
          </div>
        </div>
        <div
          className={`CatalogFormNTable ${props.contentClassName ?? ""}`.trim()}
        >
          {props.dataAdminChildren}
          {Children.map(props.children, (child) => (
            <> {child} </>
          ))}
        </div>
      </section>
    </>
  );
};

export default CatalogTableC;
